<template>
    <AutocompleteSearch />
</template>

<script setup>
    import AutocompleteSearch from '@/components/AutocompleteSearch.vue';
    import { inject } from 'vue';

    import { useSessionStore } from "@/store/storeSession.js";
    import { storeToRefs } from "pinia";

    const entryAppId = inject('global_appId');
    const entryApiKey = inject('global_apiKey');
    const entryAppIdStag = inject('global_appIdStag');
    const entryApiKeyStag = inject('global_apiKeyStag');
    const entryEnvironment = inject('global_environment');
    const entryIndex = inject('global_index');
    const entryIndexStag = inject('global_indexStag');
    const entryStore = inject('global_store');
    const entryIsAvibe = inject('global_isAvibe');
    const entryTrackAlgolia = inject('global_trackAlgolia');
    const entryImgix = inject('global_imgix');
    const entryUserToken = inject('global_userToken');
    const entryAuthUserToken = inject('global_authUserToken');
    const entryHasStore = inject('global_hasStore');

    const sessionStore = useSessionStore();
    const { appId, apiKey, appIdStag, apiKeyStag, environment, index, indexStag, storeNum, isAvibe, trackAlgolia, imgix, userToken, authUserToken, hasStore } = storeToRefs(sessionStore);

    appId.value = entryAppId;
    apiKey.value = entryApiKey;
    appIdStag.value = entryAppIdStag;
    apiKeyStag.value = entryApiKeyStag;
    environment.value = entryEnvironment;
    index.value = entryIndex;
    indexStag.value = entryIndexStag;
    storeNum.value = entryStore;
    isAvibe.value = entryIsAvibe;
    trackAlgolia.value = entryTrackAlgolia;
    imgix.value = entryImgix;
    userToken.value = entryUserToken;
    authUserToken.value = entryAuthUserToken;
    hasStore.value = entryHasStore;

    if (sessionStore.index !== localStorage.getItem('storeDC') || sessionStore.storeNum !== localStorage.getItem('storeNum')) {
        let recentSearches = localStorage.getItem('recentSearches');

        localStorage.clear();
        localStorage.setItem('storeDC', sessionStore.index);
        localStorage.setItem('storeNum', sessionStore.storeNum);

        if (recentSearches !== null)
            localStorage.setItem('recentSearches', recentSearches);
    }
</script>
